export const siteConfig = {
  brandName: "jeautyfern",
  logo: "jeautyfern",
  description:
    "A study in proportion, material and modern restraint. Designed for daily life with an exacting point of view.",
  locale: "en-US",
  currency: "USD",
  currencySymbol: "$",
  freeShippingThreshold: null,
  standardShipping: 9.99,
  contact: {
    email: "contact@jeautyfern.monster",
    address: "Hong Kong SAR",
    hours: "Monday to Friday, 9:00 AM-6:00 PM HKT",
  },
  navigation: {
    women: ["Outerwear", "Tailoring", "Dresses", "Shirts", "Knitwear", "Pants", "Denim", "Bags", "Shoes", "Jewelry"],
    men: ["Outerwear", "Tailoring", "Shirts", "Knitwear", "Tops", "Pants", "Denim", "Bags", "Shoes", "Small Leather Goods"],
  },
  formatPrice(value) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: Number(value) % 1 ? 2 : 0,
      maximumFractionDigits: 2,
    }).format(Number(value) || 0);
  },
};

const product = (item) => ({
  brand: siteConfig.brandName,
  collection: "Autumn 2026",
  badge: "",
  stock: 12,
  featured: false,
  ...item,
  sku: String(item.sku || "").replace(/^JS/, "JF"),
  attributes: {
    ...(item.attributes || {}),
    origin: "Designed in Hong Kong",
  },
});

const productData = [
  product({
    id: 1,
    sku: "JSW-OW-001",
    name: "Foldline Double-Face Coat",
    category: "Outerwear",
    gender: "Women",
    price: 179,
    image: "/img/p01-foldline-coat.jpg",
    images: ["/img/p01-foldline-coat.jpg", "/img/p01-foldline-coat-detail.jpg"],
    description: "An elongated double-face coat shaped by a precise fold through the lapel and a softly structured shoulder.",
    size: ["34", "36", "38", "40", "42"],
    colors: [{ name: "Optic White", hex: "#f1f0e9" }, { name: "Ink", hex: "#181818" }],
    material: "90% virgin wool, 10% cashmere",
    features: ["Hand-finished double-face construction", "Concealed horn-button closure", "Slant welt pockets"],
    attributes: { fit: "Relaxed, ankle length", care: "Specialist dry clean", origin: "Made in Italy" },
    tags: ["women", "outerwear", "coat", "new", "pre-fall"],
    badge: "NEW",
    featured: true,
  }),
  product({
    id: 2,
    sku: "JSW-TA-002",
    name: "Axis Collarless Blazer",
    category: "Tailoring",
    gender: "Women",
    price: 168,
    image: "/img/p02-axis-blazer.jpg",
    images: ["/img/p02-axis-blazer.jpg", "/img/p02-axis-blazer-detail.jpg"],
    description: "A collarless wool blazer with a clean neckline, curved front seams and a close architectural silhouette.",
    size: ["34", "36", "38", "40", "42"],
    colors: [{ name: "Black", hex: "#111111" }, { name: "Graphite", hex: "#4d4d4b" }],
    material: "100% compact wool",
    features: ["Collarless neckline", "Single-button closure", "Full cupro lining"],
    attributes: { fit: "Tailored fit", care: "Dry clean only", origin: "Made in Italy" },
    tags: ["women", "tailoring", "blazer", "essential"],
    featured: true,
  }),
  product({
    id: 3,
    sku: "JSW-DR-003",
    name: "Column Silk Dress",
    category: "Dresses",
    gender: "Women",
    price: 156,
    image: "/img/p03-column-dress.jpg",
    images: ["/img/p03-column-dress.jpg", "/img/p03-column-dress-detail.jpg"],
    description: "A sleeveless silk column dress drawn close at the waist with a softly draped asymmetric panel.",
    size: ["34", "36", "38", "40", "42"],
    colors: [{ name: "Cobalt", hex: "#183c91" }, { name: "Black", hex: "#111111" }],
    material: "100% silk cady",
    features: ["Asymmetric drape", "Concealed back zip", "Silk lining"],
    attributes: { fit: "Fitted, calf length", care: "Dry clean only", origin: "Made in Italy" },
    tags: ["women", "dress", "silk", "occasion", "new"],
    badge: "NEW",
    featured: true,
  }),
  product({
    id: 4,
    sku: "JSW-SH-004",
    name: "Plane Poplin Shirt",
    category: "Shirts",
    gender: "Women",
    price: 79,
    image: "/img/p04-plane-shirt.jpg",
    images: ["/img/p04-plane-shirt.jpg", "/img/p04-plane-shirt-detail.jpg"],
    description: "Crisp cotton poplin is folded across the front of this relaxed shirt to create controlled volume.",
    size: ["34", "36", "38", "40", "42"],
    colors: [{ name: "Pure White", hex: "#f5f4ef" }, { name: "Sky", hex: "#b9cede" }],
    material: "100% organic cotton poplin",
    features: ["Folded front construction", "Concealed placket", "Curved hem"],
    attributes: { fit: "Relaxed fit", care: "Machine wash cold", origin: "Made in Italy" },
    tags: ["women", "shirt", "cotton", "essential"],
  }),
  product({
    id: 5,
    sku: "JSW-KN-005",
    name: "Quiet Rib-Knit Top",
    category: "Knitwear",
    gender: "Women",
    price: 89,
    image: "/img/p05-quiet-knit.jpg",
    images: ["/img/p05-quiet-knit.jpg", "/img/p05-quiet-knit-detail.jpg"],
    description: "A finely ribbed merino top with an extended sleeve and a compact crew neckline.",
    size: ["XS", "S", "M", "L"],
    colors: [{ name: "Sage", hex: "#9ba38b" }, { name: "Black", hex: "#111111" }],
    material: "100% extra-fine merino wool",
    features: ["Fine rib construction", "Fully fashioned seams", "Extended cuffs"],
    attributes: { fit: "Close fit", care: "Hand wash cold", origin: "Made in Italy" },
    tags: ["women", "knitwear", "merino", "essential"],
  }),
  product({
    id: 6,
    sku: "JSW-PA-006",
    name: "Offset Pleat Trousers",
    category: "Pants",
    gender: "Women",
    price: 98,
    image: "/img/p06-offset-trousers.jpg",
    images: ["/img/p06-offset-trousers.jpg", "/img/p06-offset-trousers-detail.jpg"],
    description: "Fluid wool trousers cut with an offset front pleat and a long, uninterrupted wide leg.",
    size: ["34", "36", "38", "40", "42"],
    colors: [{ name: "Black", hex: "#111111" }, { name: "Pewter", hex: "#777a78" }],
    material: "98% virgin wool, 2% elastane",
    features: ["Offset double pleat", "Side pockets", "Unfinished hem for tailoring"],
    attributes: { fit: "High rise, wide leg", care: "Dry clean only", origin: "Made in Italy" },
    tags: ["women", "pants", "tailoring", "essential"],
  }),
  product({
    id: 7,
    sku: "JSW-DE-007",
    name: "Frame Denim Midi Skirt",
    category: "Denim",
    gender: "Women",
    price: 86,
    image: "/img/p07-frame-denim-skirt.jpg",
    images: ["/img/p07-frame-denim-skirt.jpg", "/img/p07-frame-denim-skirt-detail.jpg"],
    description: "A straight denim midi skirt with a centered front seam and a clean, deep indigo wash.",
    size: ["25", "26", "27", "28", "29", "30"],
    colors: [{ name: "Deep Indigo", hex: "#253346" }, { name: "Washed Black", hex: "#393938" }],
    material: "100% regenerative cotton denim",
    features: ["Five-pocket construction", "Front walking slit", "Tobacco topstitching"],
    attributes: { fit: "Regular waist, straight fit", care: "Machine wash cold", origin: "Made in Italy" },
    tags: ["women", "denim", "skirt", "pre-fall"],
  }),
  product({
    id: 8,
    sku: "JSW-BG-008",
    name: "Arc Leather Shoulder Bag",
    category: "Bags",
    gender: "Women",
    price: 145,
    image: "/img/p08-arc-shoulder-bag.jpg",
    images: ["/img/p08-arc-shoulder-bag.jpg", "/img/p08-arc-shoulder-bag-detail.jpg"],
    description: "A softly structured shoulder bag defined by an angled flap and a continuous arcing handle.",
    size: ["One Size"],
    colors: [{ name: "Black", hex: "#111111" }, { name: "Chalk", hex: "#d9d7cf" }],
    material: "Vegetable-tanned calf leather",
    features: ["Magnetic flap closure", "Adjustable shoulder strap", "Suede-lined interior"],
    attributes: { fit: "Shoulder carry", care: "Wipe with a soft dry cloth", origin: "Made in Italy", dimensions: "30 x 20 x 11 cm" },
    tags: ["women", "bag", "leather", "new"],
    badge: "NEW",
    featured: true,
  }),
  product({
    id: 9,
    sku: "JSW-BG-009",
    name: "Trace East-West Tote",
    category: "Bags",
    gender: "Women",
    price: 175,
    image: "/img/p09-trace-tote.jpg",
    images: ["/img/p09-trace-tote.jpg", "/img/p09-trace-tote-detail.jpg"],
    description: "An elongated east-west tote with slender handles and an unlined interior that celebrates the leather grain.",
    size: ["One Size"],
    colors: [{ name: "Oxblood", hex: "#4c171b" }, { name: "Black", hex: "#111111" }],
    material: "Full-grain calf leather",
    features: ["Double top handles", "Removable interior pouch", "Protective base studs"],
    attributes: { fit: "Hand or shoulder carry", care: "Leather specialist clean", origin: "Made in Italy", dimensions: "42 x 22 x 15 cm" },
    tags: ["women", "bag", "tote", "leather"],
  }),
  product({
    id: 10,
    sku: "JSW-SW-010",
    name: "Vale Square-Toe Slingback",
    category: "Shoes",
    gender: "Women",
    price: 96,
    image: "/img/p10-vale-slingback.jpg",
    images: ["/img/p10-vale-slingback.jpg", "/img/p10-vale-slingback-detail.jpg"],
    description: "A low slingback with an elongated square toe and a fine, adjustable leather strap.",
    size: ["35", "36", "37", "38", "39", "40", "41"],
    colors: [{ name: "Ivory", hex: "#ebe7dc" }, { name: "Black", hex: "#111111" }],
    material: "Smooth calf leather",
    features: ["40 mm sculpted heel", "Adjustable slingback", "Leather sole"],
    attributes: { fit: "True to size", care: "Leather specialist clean", origin: "Made in Italy" },
    tags: ["women", "shoes", "slingback", "leather", "new"],
    badge: "NEW",
  }),
  product({
    id: 11,
    sku: "JSW-SW-011",
    name: "Line Leather Loafer",
    category: "Shoes",
    gender: "Women",
    price: 92,
    image: "/img/p11-line-loafer.jpg",
    images: ["/img/p11-line-loafer.jpg", "/img/p11-line-loafer-detail.jpg"],
    description: "A pared-back leather loafer with a squared apron seam and a lightly stacked sole.",
    size: ["35", "36", "37", "38", "39", "40", "41"],
    colors: [{ name: "Black", hex: "#111111" }, { name: "Bitter Chocolate", hex: "#3b2922" }],
    material: "Polished calf leather",
    features: ["Hand-stitched apron", "Padded leather insole", "Leather and rubber sole"],
    attributes: { fit: "True to size", care: "Leather specialist clean", origin: "Made in Italy" },
    tags: ["women", "shoes", "loafer", "essential"],
  }),
  product({
    id: 12,
    sku: "JSW-JW-012",
    name: "Halo Sterling Cuff",
    category: "Jewelry",
    gender: "Women",
    price: 58,
    image: "/img/p12-halo-cuff.jpg",
    images: ["/img/p12-halo-cuff.jpg", "/img/p12-halo-cuff-detail.jpg"],
    description: "A broad open cuff shaped with a softly rounded profile and a hand-brushed surface.",
    size: ["S", "M"],
    colors: [{ name: "Brushed Silver", hex: "#c3c3bf" }],
    material: "Recycled sterling silver",
    features: ["Brushed satin finish", "Open back", "Protective cotton pouch"],
    attributes: { fit: "Adjustable opening", care: "Polish with a soft cloth", origin: "Made in Italy", dimensions: "38 mm width" },
    tags: ["women", "jewelry", "silver", "gift"],
  }),
  product({
    id: 13,
    sku: "JSM-OW-013",
    name: "Field Technical Mac",
    category: "Outerwear",
    gender: "Men",
    price: 178,
    image: "/img/p13-field-mac.jpg",
    images: ["/img/p13-field-mac.jpg", "/img/p13-field-mac-detail.jpg"],
    description: "A lightweight technical mac with a high storm collar, hidden hood and precise bonded seams.",
    size: ["44", "46", "48", "50", "52", "54"],
    colors: [{ name: "Field Sage", hex: "#8f9680" }, { name: "Black", hex: "#111111" }],
    material: "Recycled nylon twill",
    features: ["Water-repellent finish", "Concealed two-way zip", "Packable hood"],
    attributes: { fit: "Relaxed, knee length", care: "Machine wash cold", origin: "Made in Italy" },
    tags: ["men", "outerwear", "mac", "technical", "new"],
    badge: "NEW",
    featured: true,
  }),
  product({
    id: 14,
    sku: "JSM-TA-014",
    name: "Relay Wool Blazer",
    category: "Tailoring",
    gender: "Men",
    price: 169,
    image: "/img/p14-relay-blazer.jpg",
    images: ["/img/p14-relay-blazer.jpg", "/img/p14-relay-blazer-detail.jpg"],
    description: "A relaxed two-button blazer in dry-hand wool, built with a light shoulder and softly curved lapel.",
    size: ["44", "46", "48", "50", "52", "54"],
    colors: [{ name: "Charcoal", hex: "#343434" }, { name: "Ink", hex: "#181818" }],
    material: "100% virgin wool",
    features: ["Half-canvas construction", "Patch pockets", "Cupro half lining"],
    attributes: { fit: "Relaxed tailoring fit", care: "Dry clean only", origin: "Made in Italy" },
    tags: ["men", "tailoring", "blazer", "wool"],
    featured: true,
  }),
  product({
    id: 15,
    sku: "JSM-SH-015",
    name: "Grid Cotton Overshirt",
    category: "Shirts",
    gender: "Men",
    price: 112,
    image: "/img/p15-grid-overshirt.jpg",
    images: ["/img/p15-grid-overshirt.jpg", "/img/p15-grid-overshirt-detail.jpg"],
    description: "A substantial cotton overshirt with two square utility pockets and restrained tonal stitching.",
    size: ["44", "46", "48", "50", "52", "54"],
    colors: [{ name: "Optic White", hex: "#f2f1eb" }, { name: "Midnight", hex: "#202328" }],
    material: "100% organic cotton canvas",
    features: ["Double chest pockets", "Corozo buttons", "Side seam pockets"],
    attributes: { fit: "Boxy fit", care: "Machine wash cold", origin: "Made in Italy" },
    tags: ["men", "shirt", "overshirt", "cotton"],
  }),
  product({
    id: 16,
    sku: "JSM-KN-016",
    name: "Still Merino Crewneck",
    category: "Knitwear",
    gender: "Men",
    price: 99,
    image: "/img/p16-still-crewneck.jpg",
    images: ["/img/p16-still-crewneck.jpg", "/img/p16-still-crewneck-detail.jpg"],
    description: "A clean crewneck in dense extra-fine merino with fully fashioned raglan shoulders.",
    size: ["XS", "S", "M", "L", "XL"],
    colors: [{ name: "Cobalt", hex: "#1f438b" }, { name: "Charcoal", hex: "#444442" }],
    material: "100% extra-fine merino wool",
    features: ["Fully fashioned shoulders", "Compact rib trims", "Twelve-gauge knit"],
    attributes: { fit: "Regular fit", care: "Hand wash cold", origin: "Made in Italy" },
    tags: ["men", "knitwear", "merino", "new"],
    badge: "NEW",
  }),
  product({
    id: 17,
    sku: "JSM-TP-017",
    name: "Seam Heavyweight Tee",
    category: "Tops",
    gender: "Men",
    price: 49,
    image: "/img/p17-seam-tee.jpg",
    images: ["/img/p17-seam-tee.jpg", "/img/p17-seam-tee-detail.jpg"],
    description: "A compact jersey T-shirt with a precise neckline and shifted shoulder seam.",
    size: ["XS", "S", "M", "L", "XL"],
    colors: [{ name: "Black", hex: "#111111" }, { name: "Optic White", hex: "#f2f1eb" }],
    material: "100% heavyweight organic cotton",
    features: ["Bound crew neck", "Shifted shoulder seam", "Twin-needle hem"],
    attributes: { fit: "Relaxed fit", care: "Machine wash cold", origin: "Made in Portugal" },
    tags: ["men", "top", "t-shirt", "cotton", "essential"],
  }),
  product({
    id: 18,
    sku: "JSM-PA-018",
    name: "Vector Pleat Trousers",
    category: "Pants",
    gender: "Men",
    price: 95,
    image: "/img/p18-vector-trousers.jpg",
    images: ["/img/p18-vector-trousers.jpg", "/img/p18-vector-trousers-detail.jpg"],
    description: "Wide wool trousers cut with deep forward pleats and a long, clean break over the shoe.",
    size: ["44", "46", "48", "50", "52", "54"],
    colors: [{ name: "Cool Grey", hex: "#a5a6a4" }, { name: "Black", hex: "#111111" }],
    material: "100% tropical wool",
    features: ["Double forward pleat", "Extended waistband tab", "Back welt pockets"],
    attributes: { fit: "High rise, wide leg", care: "Dry clean only", origin: "Made in Italy" },
    tags: ["men", "pants", "tailoring", "wool"],
  }),
  product({
    id: 19,
    sku: "JSM-DE-019",
    name: "Rawline Straight Jeans",
    category: "Denim",
    gender: "Men",
    price: 82,
    image: "/img/p19-rawline-jeans.jpg",
    images: ["/img/p19-rawline-jeans.jpg", "/img/p19-rawline-jeans-detail.jpg"],
    description: "Straight five-pocket jeans in rinsed black denim with a raw-edged internal waistband detail.",
    size: ["28", "29", "30", "31", "32", "33", "34", "36"],
    colors: [{ name: "Washed Black", hex: "#3b3b3a" }, { name: "Rinse Indigo", hex: "#283342" }],
    material: "100% regenerative cotton denim",
    features: ["Five-pocket construction", "Metal tack button", "Tonal stitching"],
    attributes: { fit: "Mid rise, straight leg", care: "Machine wash cold", origin: "Made in Italy" },
    tags: ["men", "denim", "jeans", "essential"],
  }),
  product({
    id: 20,
    sku: "JSM-BG-020",
    name: "Volume Leather Tote",
    category: "Bags",
    gender: "Men",
    price: 176,
    image: "/img/p20-volume-tote.jpg",
    images: ["/img/p20-volume-tote.jpg", "/img/p20-volume-tote-detail.jpg"],
    description: "An oversized unlined tote in supple leather with broad side gussets and reinforced handles.",
    size: ["One Size"],
    colors: [{ name: "Black", hex: "#111111" }, { name: "Stone", hex: "#9b968c" }],
    material: "Tumbled calf leather",
    features: ["Unlined construction", "Interior zipped pouch", "Reinforced top handles"],
    attributes: { fit: "Hand or shoulder carry", care: "Leather specialist clean", origin: "Made in Italy", dimensions: "48 x 36 x 18 cm" },
    tags: ["men", "bag", "tote", "leather", "new"],
    badge: "NEW",
    featured: true,
  }),
  product({
    id: 21,
    sku: "JSM-BG-021",
    name: "Notch Leather Crossbody",
    category: "Bags",
    gender: "Men",
    price: 135,
    image: "/img/p21-notch-crossbody.jpg",
    images: ["/img/p21-notch-crossbody.jpg", "/img/p21-notch-crossbody-detail.jpg"],
    description: "A compact crossbody bag with softened corners, an offset zip and a wide adjustable strap.",
    size: ["One Size"],
    colors: [{ name: "Olive", hex: "#555746" }, { name: "Black", hex: "#111111" }],
    material: "Grained calf leather",
    features: ["Two-way zip closure", "Adjustable webbed strap", "Internal card pocket"],
    attributes: { fit: "Crossbody carry", care: "Wipe with a soft dry cloth", origin: "Made in Italy", dimensions: "24 x 18 x 8 cm" },
    tags: ["men", "bag", "crossbody", "leather"],
  }),
  product({
    id: 22,
    sku: "JSM-SM-022",
    name: "Plane Leather Derby",
    category: "Shoes",
    gender: "Men",
    price: 105,
    image: "/img/p22-plane-derby.jpg",
    images: ["/img/p22-plane-derby.jpg", "/img/p22-plane-derby-detail.jpg"],
    description: "A clean five-eyelet derby with a softly squared toe and a lightweight stacked sole.",
    size: ["39", "40", "41", "42", "43", "44", "45"],
    colors: [{ name: "Black", hex: "#111111" }, { name: "Dark Brown", hex: "#392923" }],
    material: "Polished calf leather",
    features: ["Five-eyelet lace-up", "Padded leather lining", "Leather and rubber sole"],
    attributes: { fit: "True to size", care: "Leather specialist clean", origin: "Made in Italy" },
    tags: ["men", "shoes", "derby", "leather"],
  }),
  product({
    id: 23,
    sku: "JSM-SM-023",
    name: "Court Leather Sneaker",
    category: "Shoes",
    gender: "Men",
    price: 78,
    image: "/img/p23-court-sneaker.jpg",
    images: ["/img/p23-court-sneaker.jpg", "/img/p23-court-sneaker-detail.jpg"],
    description: "A low-profile leather sneaker reduced to clean panels, tonal laces and a matte rubber sole.",
    size: ["39", "40", "41", "42", "43", "44", "45"],
    colors: [{ name: "Off White", hex: "#e5e1d5" }, { name: "Black", hex: "#111111" }],
    material: "Nappa leather",
    features: ["Tonal lace-up", "Removable leather footbed", "Rubber cupsole"],
    attributes: { fit: "True to size", care: "Wipe with a damp cloth", origin: "Made in Italy" },
    tags: ["men", "shoes", "sneaker", "essential"],
  }),
  product({
    id: 24,
    sku: "JSM-SL-024",
    name: "Orbit Card Holder",
    category: "Small Leather Goods",
    gender: "Men",
    price: 45,
    image: "/img/p24-orbit-cardholder.jpg",
    images: ["/img/p24-orbit-cardholder.jpg", "/img/p24-orbit-cardholder-detail.jpg"],
    description: "A slim card holder with curved cut lines, five slots and a softly burnished edge.",
    size: ["One Size"],
    colors: [{ name: "Oxblood", hex: "#4c171b" }, { name: "Black", hex: "#111111" }],
    material: "Grained calf leather",
    features: ["Five card slots", "Central receipt pocket", "Hand-painted edges"],
    attributes: { fit: "Pocket size", care: "Wipe with a soft dry cloth", origin: "Made in Italy", dimensions: "10 x 7.5 cm" },
    tags: ["men", "small leather goods", "card holder", "gift"],
  }),
  product({
    id: 25,
    sku: "JFU-BG-025",
    name: "Fern Curve Crossbody",
    category: "Bags",
    gender: "Unisex",
    price: 69,
    image: "/img/p25-fern-curve-crossbody.jpg",
    images: [
      "/img/p25-fern-curve-crossbody.jpg",
      "/img/p25-fern-curve-crossbody-detail.jpg",
    ],
    description:
      "A lightweight crescent crossbody in matte fern-green nylon with an adjustable woven strap and easy-access zipped pockets.",
    size: ["One Size"],
    colors: [{ name: "Fern Green", hex: "#44533a" }],
    material: "Recycled nylon with polyester lining",
    features: ["Zip-top closure", "Adjustable woven strap", "Front and rear pockets"],
    attributes: {
      fit: "Crossbody carry",
      care: "Wipe clean with a damp cloth",
      dimensions: "29 x 19 x 8 cm",
    },
    tags: ["unisex", "bag", "crossbody", "nylon", "new"],
    badge: "NEW",
    featured: true,
  }),
];

export default productData;
